import { render, staticRenderFns } from "./vastuuhenkilot.vue?vue&type=template&id=0c4357ee&"
import script from "./vastuuhenkilot.vue?vue&type=script&lang=ts&"
export * from "./vastuuhenkilot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports